import { A as AppFadeView } from '../../dist/index-948166a0.esm.js';
export { A as default } from '../../dist/index-948166a0.esm.js';
import 'react';
import 'react-native';
